import { z } from 'zod'

export const workWvsLegacyAliasResponseSchema = z.object({}).passthrough()
export type WorkWvsLegacyAliasResponse = z.infer<typeof workWvsLegacyAliasResponseSchema>
